import React, { memo, useState, useContext } from 'react'
import styles from './index.module.less'
import Portal from '@/base-components/portal'
import Toast from 'antd-mobile/es/toast'
import classnames from 'classnames'
import context from '@/components/poizon-fission/context'
import { getEmailCode, checkEmailCode, singUpByEmail } from '../../../apis'
import { ICodeParams } from '../../../types'
import { getUUID } from '@/utils'
import Protocols from './protocols'
import md5 from 'md5'
import { isAndroid } from '@/utils/appUtils/getDevice'

const Modal: React.FC<{
  visible: boolean
  inviteCode: string
  callback: (val?: boolean, val2?: boolean) => void
}> = ({ inviteCode, visible, callback }) => {
  const {
    lang,
    local,
    invite: { register },
  } = useContext(context)

  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')
  const [text, setText] = useState(register.send)
  const [codeInajax, setCodeInajax] = useState(false)
  const [checked, setChecked] = useState(false)
  const [isValid, setValid] = useState(false)
  const [initClientHeight, setClientHeight] = useState(
    document.documentElement.clientHeight || document.body.clientHeight
  )

  // email input change
  const emailChange = (e: any) => {
    setEmail(e.target.value)
  }

  // code input change
  const codeChange = (e: any) => {
    const val = e.target.value
    setCode(val)
    if (email && val.length == 4) {
      codeCheckEvent(val)
    }
  }

  // password inut change
  const PasswordChange = (e: any) => {
    setPassword(e.target.value)
  }

  // 协议checkbox事件
  const onProtocolChecked = () => {
    setChecked(!checked)
  }

  const onBlur = () => {
    /******* 去除键盘弹起后恢复输入框位置错乱的bug *******/
    setTimeout(function () {
      // const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
      // window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      window.scrollTo(0, 0)
    }, 20)
  }

  const onFocus = () => {
    /******* 兼容android收起键盘并不会触发输入框的 blur 失焦事件 *******/
    if (isAndroid()) {
      window.onresize = () => {
        // 当前页面高度
        const curClientHeight = document.documentElement.clientHeight || document.body.clientHeight
        const activeElement = document.activeElement

        if (curClientHeight < initClientHeight) {
          // 键盘弹出
          if (
            activeElement &&
            (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')
          ) {
            setTimeout(() => {
              //焦点元素滚到可视区域的问题
              activeElement.scrollIntoView({ block: 'center' })
            }, 20)
          }
        } else {
          // 键盘收起
          window.scrollTo(0, 0)
        }
      }
    }
  }

  // get code btn click
  const getCode = () => {
    if (codeInajax) {
      return
    }
    if (email.length === 0) {
      Toast.info(register.email)
      return
    }
    if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email)) {
      Toast.info(register.emailError)
      return
    }
    setCodeInajax(true)
    runtime(60)

    codeBtnEvent()
  }

  // count down
  const runtime = (time: number) => {
    const timer = setInterval(() => {
      if (time <= 0) {
        setCodeInajax(false)
        setText(register.send)
        if (timer) {
          clearInterval(timer)
        }
      } else {
        time--
        setText(() => `${time}s${register.resend}`)
      }
    }, 1000)
  }

  // login btn click
  const loginTrick = async () => {
    if (email.length === 0) {
      Toast.info(register.email)
      return
    }
    if (code.length === 0) {
      Toast.info(register.code)
      return
    }
    if (password.length === 0) {
      Toast.info(register.password)
      return
    }
    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/.test(password)) {
      Toast.info(register.passwordRule)
      return
    }

    singUpEvent()
  }

  const IBody: ICodeParams = {
    email,
    captchaType: 'SIGNUP',
    reqSource: 1,
    countryCode: local,
    uid: 0,
    language: lang,
  }

  // 调用获取code的方法
  const codeBtnEvent = async () => {
    return await getEmailCode(IBody)
  }

  // 校验验证码code的方法
  const codeCheckEvent = (value: string) => {
    const body = Object.assign({}, IBody, { code: value })
    checkEmailCode(body)
      .then((res) => {
        if (res.code == 200) {
          setValid(true)
        }
      })
      .catch((e) => {
        setValid(false)
      })
  }

  // 校验验证码code的方法
  const singUpEvent = () => {
    const body: any = {
      email,
      password: md5(password + 'du'),
      inviteCode: inviteCode,
      countryCode: local,
      uid: 0,
      language: lang,
      platform: 'H5',
      ua: navigator.userAgent,
    }

    singUpByEmail(body, { deviceId: getUUID() }).then((res) => {
      if (res.code == 200) {
        const userId = res?.data?.userId
        // 反爬需要绑定 userId
        window.dw && window.dw.bindUser(userId)
        callback(true, true)
      }
    })
  }

  if (!visible) {
    return <></>
  }
  return (
    <Portal
      visible={visible}
      didMount={() => {
        const html = document.querySelector('html')
        html.style.overflow = 'hidden'
      }}
      unMount={() => {
        const html = document.querySelector('html')
        html.style.overflow = 'auto'
      }}
    >
      <>
        <div className={styles.modalCover}>
          <div className={styles.login_box}>
            <div
              className={styles.close}
              onClick={() => {
                callback()
              }}
            ></div>

            <div className={styles.logo_box}>
              <div className={styles.text_box} />
            </div>

            <div className={styles.email_input}>
              <input
                placeholder={register.email}
                onChange={(e) => emailChange(e)}
                onBlur={() => onBlur()}
                onFocus={() => onFocus()}
                value={email}
              />
              <em
                className={classnames(styles.clear, { [styles.hide]: !!email })}
                onClick={() => setEmail('')}
              />
            </div>

            <div className={styles.line}></div>

            <div className={styles.code_input}>
              <input
                placeholder={register.code}
                maxLength={4}
                onChange={(e) => codeChange(e)}
                onBlur={() => onBlur()}
                onFocus={() => onFocus()}
              ></input>

              <div
                onClick={() => {
                  getCode()
                }}
              >
                {text}
              </div>
            </div>

            <div className={styles.line}></div>

            <div className={styles.code_input}>
              <input
                placeholder={register.password}
                id="userPassword"
                type="password"
                onChange={(e) => PasswordChange(e)}
                onBlur={() => onBlur()}
                onFocus={() => onFocus()}
                value={password}
                required
              />
              <em
                className={classnames(styles.clear, { [styles.hide]: !!password })}
                onClick={() => setPassword('')}
              />
            </div>

            <div className={styles.line}></div>
            <Protocols handle={onProtocolChecked} checked={checked} />
            <div
              className={classnames(styles.login_button, {
                [styles.valid]: email && code.length == 4 && isValid && password && checked,
              })}
              onClick={loginTrick}
            >
              {register.operate}
            </div>
          </div>
        </div>
      </>
    </Portal>
  )
}

const MemoModal = memo(Modal)

export default MemoModal
